<style  lang="scss" scoped>
    .sales-list-top {  
        height: 60px;
        padding: 0px 0 !important;
        .btn-big-small{
            padding: 15px 0;
        }
        .tangchuang{
            position: absolute;
            top:15px;
            .el-popover{
                position: absolute;
                background: #fff;
                min-width: 138px;
                border-radius: 4px;
                border: 1px solid #ebeef5;
                padding: 0px;
                z-index: 2000;
                color: #606266;
                line-height: 1.4;
                text-align: justify;
                font-size: 14px;
                box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                word-break: break-all;
            }
            .similar-name{
                position: absolute;
                top: 30px;
                left: -19px;
                // right: -413px;
                border: solid 1px #dddfe5;
                // box-shadow: inset 0px -1px 0px 0px #ececec, inset 0px 1px 0px 0px #ececec;
                width: 138px;
                // height: 100px;
                z-index: 90;
                .similar-title{
                    font-size: 14px;
                    // line-height: 50px;
                    letter-spacing: 1px;
                    color: #c1c4cc;
                }
                .similar-list{
                    .similar-row{
                        height: 48px;
                        font-size: 14px;
                        // line-height: 50px;
                        letter-spacing: 1px;
                        color: #323232;
                        cursor:pointer;
                        margin:0 20px;
                        border-bottom: 1px solid #ececec;
                        .similar-row-name{
                            margin-left: 32px;
                        }
                    }
                    .similar-row:hover{
                        color: rgba(19, 15, 223, 0.85);
                    }
                }
                .x-popper__arrow{
                    position: absolute;
                    left: -18px;
                }
                .x-popper__arrow:after,.x-popper__arrow:before {
                    top: -12px;
                    left: 126px;
                    width: 0;
                    height: 0;
                    border: 6px solid transparent;
                    border-bottom-color: #dddfe5;
                    position: absolute;
                    content: "";
                }
                .x-popper__arrow:before{
                    top: -10px;
                    left: 126px;
                    border-bottom-color: white;
                    z-index: 999;
                }
            }
        }
       .condition-title{
            font-size: 14px;
            color: #323232;
        }
        .condition-content{
            margin-left: 10px;
            font-size: 14px;
            color: #969696;
            .daitina{
                background-color: #00c2a0;
                border-radius: 2px;
                color:#fff;
                font-size: 12px;
                height: 20px;
                padding: 0px 8px ;
                margin-left: 10px;
            }
        }
        .el-button.el-button--primary{
            width: 78px
        }
        .icon-cttq-user:before{
            font-size: 13px;
            margin-right: 10px;
        }
        .el-icon-caret-bottom{
            margin-left:5px;
        }
        .countdown-item{
            background-color: #323232;
	        border-radius: 2px;
            color:#fff;
            padding: 2px 4px;
            margin-left: 5px;
            margin-right: 5px;
            width: 30px;
            height: 17px;
            font-size: 12px;
        }
        .countdown-day{
            width: 50px;
        }
        .have-published{
            background-color: #00c2a0;
            border-radius: 2px;
            color:#fff;
            font-size: 12px;
            height: 20px;
            padding: 0px 8px ;
        }
        .havejz-published {
            background-color: #ff0000;
            border-radius: 2px;
            color:#fff;
            font-size: 12px;
            height: 20px;
            padding: 0px 8px ;
        }
        .mask{
            position: fixed;
            top:0;
            left:0;
            right:0;
            bottom:0;
            z-index: 89;
        }
    }
     
</style>

<template>
    <el-row :gutter="10" class="bm bm-f1 sales-list-top" >
        <el-col :span="5" class="bm bm-ps">
            <div class="condition-title bm bm-ac">
                <span class="icon iconfont icon-cttq-user"/>
                {{configInfo.fillPersonName}}
            </div>
            <div class="bm bm-f1 condition-content bm-ac">
                {{configInfo.departName}}
                <div class="daitina bm bm-ac bm-pc" v-if="configInfo.departFlag ==1">代填</div>
            </div>
            
        </el-col>
        <el-col :span="3" class="bm bm-ps"  >
            <div class="condition-title bm bm-ac" >当前版:</div>
            <div class="bm bm-f1 condition-content bm-ac" v-on:click="showChooseVersion">
                   {{configInfo.dataVersion}}
                <i class="el-icon-caret-bottom"></i>
            </div>
            <div class="tangchuang" v-if="isChooseVersion && versionData.length>0">
                <div class="similar-name bm bm-ver el-popover">
                    <div x-arrow="" class="x-popper__arrow"></div>
                    <div class="bm bm-ver similar-list" >
                        <div v-for="(item, index) in versionData" class="bm similar-row bm-ac" :key="index"  @click="openDetailsSimilar(item.dataVersion)" >
                            <div class="bm">{{item.dataVersion}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-col>
        <el-col :span="5" class="bm bm-ps">
            <div class="condition-title bm bm-ac">填报时间：</div>
            <div class="bm bm-f1 condition-content bm-ac">
                {{configInfo.beginFillDate | dateformat('YYYY.MM.DD')}}-{{configInfo.endFillDate | dateformat('YYYY.MM.DD')}}
            </div>
        </el-col>
        <el-col :span="6" class="bm bm-ps bm-ac" v-if="configInfo.completeFlag == 2">
            <div class="have-published bm bm-ac bm-pc">已发布</div>
        </el-col>
        <!-- <el-col :span="6" class="bm bm-ps bm-ac" v-if="configInfo.completeFlag == 4">
            <div class="havejz-published bm bm-ac bm-pc">未开始</div>
        </el-col> -->
        <el-col :span="6" class="bm bm-ps bm-ac" v-if="configInfo.completeFlag == 5">
            <div class="havejz-published bm bm-ac bm-pc">已截止未发布</div>
        </el-col>
        
        <el-col :span="6" class="bm bm-ps" v-if="configInfo.completeFlag != 2 && configInfo.completeFlag != 5">
            <div class="condition-title bm bm-ac" v-if="configInfo.completeFlag != 4">距填报关闭：</div>
            <div class="condition-title bm bm-ac" v-if="configInfo.completeFlag == 4">距填报开始：</div>
            <div class="bm bm-f1 condition-content bm-ac">
                <div class="countdown bm">
                    <span class="countdown-item countdown-day bm bm-ac bm-pc" v-if="timeObj.days>0">{{timeObj.days}}天</span>
                    
                    <span class="countdown-item bm bm-ac bm-pc">{{timeObj.hours}}</span>
                    :
                    <span class="countdown-item bm bm-ac bm-pc" >{{timeObj.minutes}}</span>
                    :
                    <span class="countdown-item bm bm-ac bm-pc">{{timeObj.seconds}}</span>
                </div>
            </div>
        </el-col>
        <el-col :span="5" class="bm bm-pe btn-big-small" v-if="configInfo.completeFlag != 2 && configInfo.completeFlag != 5 && configInfo.completeFlag != 4">
            <el-button size="small" v-on:click="handleFeedback" type="primary" plain class="btn-height" :disabled="isEmpty" style="width: 178px;">反馈意见箱({{configInfo.reviewNoteCount}})</el-button>
            <el-button size="small" v-on:click="saveInfo" type="primary" plain class="btn-height" :disabled="isEmpty" >保 存</el-button>
            <el-button size="small" v-on:click="releaseInfo" type="primary" data-sensors="sensorsBtn" :data-sensors-id=dataSensorsId class="btn-height" :disabled="isEmpty" v-if="isReleaseShow">发布</el-button>
        </el-col>
        <!-- v-else -->
        <el-col :span="5" class="bm bm-pe btn-big-small" v-else> 
            <el-button size="small" v-on:click="handleFeedback" type="primary" plain class="btn-height" :disabled="isEmpty" style="width: 178px;">反馈意见箱({{configInfo.reviewNoteCount}})</el-button>
            <el-button size="small" v-on:click="releaseInfoMsg" data-sensors="sensorsBtn" :data-sensors-id=dataSensorsId type="primary" class="btn-height" v-if="isReleaseShow && configInfo.completeFlag == 5" >发布</el-button>
             <el-button size="small" v-on:click="handlewithdraw" data-sensors="sensorsBtn" :data-sensors-id=dataSensorsId type="primary" class="btn-height" :disabled="isEmpty  || configInfo.completeFlag == 4" v-else-if="configInfo.dataVersion==versionData[versionData.length-1].dataVersion&& !newPage &&!(isReleaseShow && configInfo.completeFlag == 5)" v-loading="loadingch">撤回</el-button>
        </el-col>
        <div class="mask" v-show="isChooseVersion" @click="closeMsg()"></div>
        <el-dialog
		title="反馈意见箱"
		:visible.sync="dialogVisible"
		width="640"
        custom-class="feedback-box"
		:before-close="handleClose">
			<div class="dialog-box bm bm-wrap bm-ver">
                <div class="list-row bm bm-ver">
                    <div class="row bm bm-f1"  v-for="(item, index) in listReviewNote" :key="index">
                        <div class="bm row-left " :class="index==0?'row-left-one':''">
                            <div class="online">
                                <img src="../../asserts/img/icon_liucheng.png" class="bm bm-img"/>
                            </div>
                        </div>
                        <div class="bm row-right bm-ver bm-f1">
                            <div class="p-info bm bm-pj">
                                <div class="bm agree-info bm-ac bm-pc" v-if="item.reviewResult == 1">同意发布</div>
                                <div class="bm withdraw bm-ac bm-pc" v-if="item.reviewResult == 0">建议撤回修改</div>
                                <div class="bm time">反馈时间：{{item.reviewTime | dateformat('YYYY.MM.DD HH:mm:ss')}} </div>
                            </div>
                            <div class="bm conductor">处理人：{{item.reviewerName}}_{{item.departName}}</div>
                            <div class=" p-content" v-html="item.reviewNote"></div>
                        </div>
                    </div>
                    <div v-if="listReviewNote.length<=0" class="empty-shuju bm-ac bm bm-pc">
                        暂无数据
                    </div>
                    <!-- <div class="row bm bm-f1">
                        <div class="bm row-left">
                            <div class="online">
                                <img src="../../asserts/img/icon_liucheng.png" class="bm bm-img"/>
                            </div>
                        </div>
                        <div class="bm row-right bm-ver bm-f1">
                            <div class="p-info bm bm-pj">
                                <div class="bm withdraw bm-ac bm-pc">建议撤回修改</div>
                                <div class="bm time">反馈时间：2019-11-15  16:10:02</div>
                            </div>
                            <div class="bm conductor">处理人：张海东_财会一部</div>
                            <div class="bm p-content">1、后即可很快就好看好看好看；</div>
                        </div>
                    </div>
                    <div class="row bm bm-f1">
                        <div class="bm row-left">
                            <div class="online">
                                <img src="../../asserts/img/icon_liucheng.png" class="bm bm-img"/>
                            </div>
                        </div>
                        <div class="bm row-right bm-ver bm-f1">
                            <div class="p-info bm bm-pj">
                                <div class="bm agree-info bm-ac bm-pc">同意发布</div>
                                <div class="bm time">反馈时间：2019-11-15  16:10:02</div>
                            </div>
                            <div class="bm conductor">处理人：张海东_财会一部</div>
                            <div class="bm p-content">1、后即可很快就好看好看好看；</div>
                        </div>
                    </div>
                    <div class="row bm bm-f1">
                        <div class="bm row-left">
                            <div class="online">
                                <img src="../../asserts/img/icon_liucheng.png" class="bm bm-img"/>
                            </div>
                        </div>
                        <div class="bm row-right bm-ver bm-f1">
                            <div class="p-info bm bm-pj">
                                <div class="bm agree-info bm-ac bm-pc">同意发布</div>
                                <div class="bm time">反馈时间：2019-11-15  16:10:02</div>
                            </div>
                            <div class="bm conductor">处理人：张海东_财会一部</div>
                            <div class="bm p-content">1、后即可很快就好看好看好看；</div>
                        </div>
                    </div> -->
                </div>
			</div>
		
		</el-dialog>
    </el-row>
</template>

<script>
import { $cacheUtil } from '@/utils'
import { configDataApi } from "@/services";
export default {
    name: "sales-list-top",
    data() {
        return {
            loadingch:false,
            loading:false,
            isRepeatClick:false,
            listReviewNote:[],
            dialogVisible: false,
            isChooseVersion:false,
            configInfo:Object.assign({},this.$store.state.init.initData),
            sth:"",
            field:[],
            newPage: false,
            timeObj:{
                days:0,
                hours:0,
                minutes:0,
                seconds:0,
            },
            versionData:this.$store.state.init.versionData,
			dataSensorsId:""
        };
    },
    props: {
        isReleaseShow:{
            type: Boolean,
            default:true,
		},
        isEmpty:{
            type: Boolean
		},
        tableData:{
            type: Array
		},
        col: {
            type: Object
        },
        editField:{
            type: Array
		},
		width:{
			type: String
		},
		height:{
			type: String
		}
	},
	
    created(){
       if(this.$route.meta && this.$route.meta.eventId && this.$route.meta.name) { // 有埋点标识的页面
			// 引入神策埋点
			this.dataSensorsId = this.$route.meta.eventId
		}
    },
    mounted(){
        if(this.$route.query.newPage){
            this.newPage = this.$route.query.newPage;
            $cacheUtil.removeItem("dataInitParamTemp");//清理掉 临时资源吗
        }
        //禁止后退
        history.pushState(null, null, document.URL);
		window.addEventListener('popstate', function () {
			history.pushState(null, null, document.URL);
        });
        //
        // console.log($cacheUtil.getItem("dataInitParamTemp"))
        // $cacheUtil.removeItem("dataInitParamTemp");
        let endtime = this.configInfo.endFillDate+24*3600*1000;
        let beginFillDate = this.configInfo.beginFillDate;
        if(this.configInfo.completeFlag != 2){
            //还没有开始
            if(beginFillDate >  Date.parse(new Date())){
                this.configInfo.completeFlag = 4;
                this.timeDown(beginFillDate);
            }//大于填报结束时间了
            else if(endtime <=  Date.parse(new Date())){
                this.configInfo.completeFlag = 5;
            }else{
                this.timeDown(endtime);
            }
        }
        
    },
    methods: {
        handlewithdraw(){
            this.loadingch =true;
            let that =this;
            let endtime = this.configInfo.endFillDate+24*3600*1000;
            // console.log(endtime <=  Date.parse(new Date()));
            if(endtime <=  Date.parse(new Date())){
                this.$alert('填报时间已结束，无法撤回，请联系系统管理员或与您对接的运营人员', '友情提醒', {
                    confirmButtonText: '确定',
                    type: 'warning'
                    }).then(() => {
                       that.loadingch =false;
                    }).catch(() => {      
                });
            }else{
                if(that.isRepeatClick){
                    return false;
                }
                that.isRepeatClick =true;
                this.$confirm('撤回将导致财务审核人无法审核，是否确认？', '友情提醒', {
                    confirmButtonText: '继续撤回',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        configDataApi.bugetRecall({configurationId:that.configInfo.configurationId,personName:this.$store.state.user.userInfo.personName,personCode:this.$store.state.user.userInfo.personCode,}).then(res => {
                            if (res && res.msgCode == '100' ) {
                                that.isRepeatClick =false;
                                that.loadingch =false;
                                that.$emit("releaseInfo", "撤回");

                                // this.$message({
                                //     type: 'success',
                                //     message: '撤回成功!'
                                // });
                            }else{
                                 that.loadingch =false;
                            }
                        });
                    }).catch(() => {
                        that.loadingch =false;
                        that.isRepeatClick =false;
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });          
                });
                
            }
           
        },
        handleClose(done) {
			// this.$confirm('确认关闭？')
			// .then(_ => {
			// 	done();
			// })
            // .catch(_ => {});
            this.dialogVisible =false;
		},
        closeMsg(){
            this.isChooseVersion = false;
        },
        showChooseVersion(){
            this.isChooseVersion = true;
        },
        openDetailsSimilar(e){
            this.isChooseVersion = false;
            let that = this;
            // this.configinfo.dataVersion = e;
            //let configinfo = JSON.parse(JSON.stringify(this.configInfo));
            let param = $cacheUtil.getObject("dataInitParam");
            let dataInitParamTemp = $cacheUtil.getObject("dataInitParamTemp");
            //有临时表参数 ，优先考虑临时表参数
            if(dataInitParamTemp){
                param = dataInitParamTemp;
            }
            
            let dataVersion = this.$route.query.dataVersion;
            // if(dataVersion){
            //     param.dataVersion = dataVersion;
            // }else{
            param.dataVersion = e;
            $cacheUtil.setObject("dataInitParam", param);//初始化表入参，页面刷新参数从缓存取
            // }
            // this.configinfo =configinfo;
            // console.log("入参",param)
            //因为数据重新mock 所以版本刷不了
            this.$store.dispatch('init/getDataInit',param).then(res => {
                if (res && res.msgCode == '100' ) {
                    // sales/price
                    var domain = window.location.href;
                    let newUrl = domain.substr(domain.indexOf("WebPC/"),domain.length);
                    that.configInfo = res.responseData;
                    // console.log("aa",res);
                    // if(domain.indexOf("Fill") !=-1){
                        console.log(res.responseData)
                    if(res.responseData.completeFlag == 2){
                        this.$router.push({ path: newUrl.replace("WebPC/","/").replace("Fill","Check").replace("/fill","/check") , query: {dataVersion: e}});
                    }else{
                        this.$router.push({ path: newUrl.replace("WebPC/","/").replace("Check","Fill").replace("/check","/fill") , query: {dataVersion: e}});
                    }
                    // that.$emit("getVersion", res);
                }
            });
           
        },
        handleFeedback(){
            let that =this;
            configDataApi.findListReviewNote(this.configInfo.configurationId).then(res => {
				if (res && res.msgCode == '100' ) {
                    that.listReviewNote=res.responseData;
					that.dialogVisible = true;
				}
			});
           
        },
        //保存列表信息
        saveInfo(e){
            this.$emit("saveInfo", "保存");
        },
        //发布列表信息
        releaseInfoMsg(e){
            this.$alert(`填报时间已结束，无法发布，请联系系统管理员或与您对接的运营人员`, '友情提醒', {
                confirmButtonText: '确定',
                callback: action => {
                    
                }
            });
            // console.log(e);
            // this.$emit("releaseInfo", "发布");
        },
        //发布列表信息
        releaseInfo(e){            
            this.loading =true;
            let that =this;
            if(that.isRepeatClick){
                return false;
            }
            that.isRepeatClick =true;
            setTimeout(function () {
                that.isRepeatClick =false;
            }, 1000)
            this.$emit("releaseInfo", "发布");
        },
        /*
        时间倒计时插件
        */
        timeDown(endDateStr) {
            //结束时间
            var endDate = endDateStr;
            //当前时间
            var nowDate = new Date();
            //相差的总秒数
            var totalSeconds = parseInt((endDate - nowDate) / 1000);
            //天数
            this.timeObj.days = Math.floor(totalSeconds / (60 * 60 * 24));
            //取模（余数）
            var modulo = totalSeconds % (60 * 60 * 24);
            //小时数
            this.timeObj.hours = Math.floor(modulo / (60 * 60));
            modulo = modulo % (60 * 60);
            //分钟
            this.timeObj.minutes = Math.floor(modulo / 60);
            //秒
            this.timeObj.seconds = modulo % 60;
            //输出到页面
            //延迟一秒执行自己
            let that = this;
            if(this.timeObj.days <= 0 && this.timeObj.hours <=0 && this.timeObj.minutes <=0 && this.timeObj.seconds <=0 ){
                if(this.configInfo.completeFlag==1 || this.configInfo.completeFlag==0 || this.configInfo.completeFlag==3){ //
                    that.$router.go(0)  
                }
            }else{
                setTimeout(function () {
                    that.timeDown(endDateStr);
                }, 1000)
            }
            
        }
    }
};
</script>
<style >
.feedback-box .el-dialog__body{
     padding: 5px 20px;
}
.row .row-right .p-content img{
    width:100%;
}
</style>
<style scoped lang="scss">
.dialog-box{
   
    padding: 40px 0;
    border-top:1px solid #e6e6e6;
    .list-row{
        height: 360px;
        overflow:auto;
        .empty-shuju{

        }
         .row{
            
            .row-left{
                padding-top:0px ;
                width: 40px;
                .online{
                    position: relative;
                    height: 100%;
                }
                .online::after{
                    content: "";
                    position: absolute;
                    margin-top: 0px;
                    width: 2px;
                    height: 100%;
                    background-color: #e1e1e1;
                    margin-left: 10px;
                    z-index: 99;
                }
                img{
                    position:absolute;
                    z-index: 100;
                    left: 3px;
                    top: 3px;
                }
            }
            .row-left-one{
                padding-top:10px ;
                 img{
                    position:absolute;
                    z-index: 100;
                    left: 3px;
                    top: 0px;
                }
            }
            .row-right{
                .withdraw{
                    padding:0 5px;
                    height: 20px;
                    background-color: #fcf0f0;
                    border-radius: 2px;
                    border: solid 1px #f9e3e3;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 17px;
                    letter-spacing: 0px;
                    color: #e46561;
                }
                .agree-info{
                    padding:0 5px;
                    height: 20px;
                    background-color: #f2f9ec;
                    border-radius: 2px;
                    border: solid 1px #e4f2da;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 17px;
                    letter-spacing: 0px;
                    color: #6fbf3b;
                }
                .time{
                    
                    height: 14px;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 17px;
                    letter-spacing: 0px;
                    color: #969696;
                }
                .conductor{
                    margin:6px 0 10px;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 17px;
                    letter-spacing: 0px;
                    color: #323232;
                }
                .p-content{
                    // margin: 14px 0 0 0 ;
                    background-color: #f8f8f8;
                    padding: 15px;
                    margin-bottom: 20px;
                   
                }
            }
        }
    }
   
}
</style>